import React from "react";
import "./ConnectWithUs.css";
import shield from "../assets/images/coinSvg.png";
import { useSocialLinks } from "../hooks/useSocialLinks";

const ConnectWithUs = () => {
  const {
    data: socialLinks = [],
    isLoading,
    isError,
    error,
  } = useSocialLinks();
  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load social links."
    : "";

  return (
    <div className="connect-card">

      <div className="connect-heading">
        <h2>Connect With Us</h2>
        <p>Updates • Tips • Live Sessions</p>
      </div>

      <div className="connect-icons">
        {isLoading ? <p className="connect-card__status">Loading social links...</p> : null}
        {!isLoading && loadError ? <p className="connect-card__status connect-card__status--error">{loadError}</p> : null}
        {!isLoading && !loadError && !socialLinks.length ? (
          <p className="connect-card__status">No social links available.</p>
        ) : null}

        {!isLoading && !loadError && socialLinks.map((item, index) => (
          <a
            className="social-item"
            key={`${item?.title || "social"}-${index}`}
            href={item?.link || "#"}
            target="_blank"
            rel="noreferrer"
            aria-label={item?.title || "Social Link"}
          >
            <div className="social-image">
              <img src={item?.icon} alt={item?.title || "Social Link"} />
            </div>

            <span>{item?.title || "Social"}</span>
          </a>
        ))}

      </div>

      <div className="connect-divider"></div>

      <div className="connect-footer">

        <div className="footer-left">
          <img src={shield} alt="" />
          <span>Follow us for daily VidyaKasam Education updates</span>
        </div>
      </div>

    </div>
  );
};

export default ConnectWithUs;
